// extracted by mini-css-extract-plugin
export default {"title":"page-title_title__cC5K1"};